import { useLazyQuery, useMutation, useApolloClient } from '@apollo/client';
import {
  ImportPatientsWithCsv,
  LoadPatientsImportStatus,
} from '../gqlSchemes/importPatients';
import { GET_PATIENTS } from '../gqlSchemes/getPatients';
import { useTranslation } from 'react-i18next';

export default function useImportPatients() {
  const [importPatientsWithCsv] = useMutation(ImportPatientsWithCsv);
  const [loadPatientsImportStatus] = useLazyQuery(LoadPatientsImportStatus);
  const { t } = useTranslation();

  const client = useApolloClient();

  const onImportPatients = async (variables) => {
    return new Promise(async (resolve, reject) => {
      try {
        const importResult = await importPatientsWithCsv({
          variables: variables,
        });

        const importResultData =
          importResult?.data?.user?.patientUser?.invitePatientsWithCsv;

        if (!importResultData?.ok) {
          throw new Error('Import failed');
        }
        const taskId = importResultData.result?.taskId;

        let interval = setInterval(async () => {
          const { data } = await loadPatientsImportStatus({
            variables: { taskId },
          });
          const status =
            data?.user?.patient?.invitePatientsWithCsvStatus?.taskStatus;

          if (status === 'SUCCESS') {
            client.refetchQueries({
              include: [GET_PATIENTS],
            });
            resolve(data);
            clearInterval(interval);
            interval = null;
          }
        }, 3000);
        setTimeout(() => {
          clearInterval(interval);
          interval = null;
          reject(new Error(t('Something went wrong. Please, try again later')));
        }, 30000);
      } catch (error) {
        // Handle any errors that occurred during the process
        console.error('Error:', error.message);
        reject(error);
      }
    });
  };

  return {
    onImportPatients,
  };
}
